import axios from "axios"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"

const ImportProjectData = ({
  importDataToggle,
  setAuth,
  setInsertedDataResult,
  importedDataResultToggle,
}) => {
  const history = useHistory()

  const [modal, setModal] = useState(true)
  const [baladiFile, setBaladiFile] = useState(null)
  const [tawuniyaFile, setTawuniyaFile] = useState(null)

  const [errors, setErrors] = useState({
    general: "",
    baladi: "",
    tawuniya: "",
  })

  const [selectedOption, setSelectedOption] = useState() // Default to "baladi"
  const handleChange = e => {
    setSelectedOption(e.target.value)
  }

  const toggle = () => importDataToggle()
  const onClose = () => importDataToggle()

  useEffect(() => {
    setErrors({ general: "", baladi: "", tawuniya: "" })
    // if (!selectedOption) {
    //   setErrors({ general: "Kindly select option above" })
    // }

    if (selectedOption === "baladi" && !baladiFile) {
      setErrors(errors => ({ ...errors, baladi: "required" }))
    }

    if (selectedOption === "tawuniya" && !tawuniyaFile) {
      setErrors(errors => ({ ...errors, tawuniya: "required" }))
    }
  }, [selectedOption, baladiFile, tawuniyaFile])

  const submitHandler = () => {
    setErrors({})

    if (!selectedOption) {
      return setErrors({ general: "Kindly select option above" })
    }
    const formData = new FormData()
    formData.append("PerToken", localStorage.getItem("token"))
    formData.append("PerUserID", localStorage.getItem("id"))
    formData.append("PerRoleID", localStorage.getItem("userRoleID"))

    if (selectedOption === "baladi") {
      if (!baladiFile) {
        return setErrors(errs => ({ ...errs, baladiFile: "required" }))
      }

      formData.append("Balady", baladiFile)
    }

    if (selectedOption === "tawuniya") {
      if (!tawuniyaFile) {
        return setErrors(errs => ({ ...errs, tawuniyaFile: "required" }))
      }

      formData.append("Tawuniya", tawuniyaFile)
    }

    axios
      .post(process.env.REACT_APP_API_URL + "api/import.php", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
          setLoading(false)
          return
        }

        console.log("res.data", res.data)
        if (selectedOption === "baladi" && res.data?.summary.duplicates > 0) {
          const duplicatedResults = res.data.results.filter(
            result => result.duplicates
          )
          setInsertedDataResult(duplicatedResults)
          importedDataResultToggle()
        }
      })
      .catch(error => {
        console.log("error", error)
      })
      .finally(() => {
        importDataToggle()
      })
  }

  const baladiTemplateHandler = () => {}

  return (
    <Modal isOpen={modal} toggle={toggle} className="modal-lg">
      <ModalHeader>
        Import Project Data
        <button
          type="button"
          className="btn-close position-absolute end-0 top-0 m-3"
          onClick={onClose}
        />
      </ModalHeader>

      <ModalBody>
        <h6>Kindly check only one uploading list below:</h6>
        <Row className="align-items-center mt-4">
          <Col sm={1} className="d-flex justify-content-end">
            <Input
              type="radio"
              name="project-data"
              id="baladi"
              value="baladi"
              //   checked={selectedOption === "baladi"}
              onChange={handleChange}
            />
          </Col>
          <Col>
            <label
              htmlFor="baladi"
              className="mb-0"
              style={{ cursor: "pointer" }}
            >
              Balady Requests List
            </label>
          </Col>
          <Col>
            <Input
              type="file"
              accept=".xls,.xlsx,.csv"
              disabled={selectedOption !== "baladi"}
              onChange={e => setBaladiFile(e.target.files[0])}
            />
            <div className="d-flex justify-content-between">
              <p className="my-0 d-flex justify-content-end">
                Download CSV Template{" "}
                <a
                  className="mx-1"
                  href={`${process.env.REACT_APP_API_URL}uploads/BALADY.csv`}
                >
                  here
                </a>
              </p>
              {errors.baladi && (
                <p className="my-0 text-danger d-flex justify-content-start">
                  {errors.baladi}
                </p>
              )}
            </div>
          </Col>
        </Row>

        <Row className="align-items-center my-5">
          <Col sm={1} className="d-flex justify-content-end">
            <Input
              type="radio"
              name="project-data"
              id="tawuniya"
              value="tawuniya"
              //   checked={selectedOption === "tawuniya"}
              onChange={handleChange}
            />
          </Col>
          <Col>
            <label
              htmlFor="tawuniya"
              className="mb-0"
              style={{ cursor: "pointer" }}
            >
              Tawuniya IDI List
            </label>
          </Col>
          <Col>
            <Input
              type="file"
              accept=".xls,.xlsx,.csv"
              disabled={selectedOption !== "tawuniya"}
              onChange={e => setTawuniyaFile(e.target.files[0])}
            />
            <div className="d-flex justify-content-between">
              <p className="my-0 d-flex justify-content-end">
                Download CSV Template{" "}
                <a
                  className="mx-1"
                  href={`${process.env.REACT_APP_API_URL}uploads/Tawuniya.csv`}
                >
                  here
                </a>
              </p>
              {errors.tawuniya && (
                <p className="my-0 text-danger d-flex justify-content-start">
                  {errors.tawuniya}
                </p>
              )}
            </div>
          </Col>
        </Row>

        <p className="my-0 text-danger d-flex justify-content-end">
          {errors.general}
        </p>
        <Row>
          <Col className="d-flex justify-content-end">
            <Button color="primary" onClick={submitHandler}>
              Submit
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default ImportProjectData
